export default "__VITE_ASSET__B3KdhU$T__"